// Vanilla CSS for FullCard. Prefix: fc-. Aggregated into libraryStyles.
// The default FullCard surface is frosted "Playful Frost" glass — translucent
// warm-white fill + backdrop blur + top-edge light + soft teal float shadow —
// matching the design system's `Card variant="glass"`. The backgroundColor /
// borderColor / opacity props still override the *-default classes (e.g. a
// solid-white surface for dense tables).
export const cardStyles = `
  .fc-card {
    position: relative;
    min-height: 100%;
    width: 100%;
    border-radius: var(--rad-catchup-xlarge);
    /* No backdrop-filter — FullCard is the big content surface on ~22 screens
       (often an ancestor of scrolling content); blur only frosts the flat page
       bg (pure raster cost). The frosted look is the near-opaque fill below. */
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  }
  .fc-card > * { position: relative; z-index: 1; }
  .fc-bg-default {
    background-color: var(--glass-flat-solid);
  }
  .fc-border-default {
    border: 1px solid var(--glass-flat-border);
  }
  .fc-opacity-default { opacity: 1; }
  /* bare: transparent, no glass — lets nested glass children blur the page
     (avoids the flat "glass-inside-glass" look). Keeps padding/layout. */
  .fc-card.fc-bare {
    background-color: transparent;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    box-shadow: none;
    /* A bare card must reserve NO border box — the default 1px border (even when
       transparent) would offset its content 1px right + down vs. screens that
       render straight on the page (e.g. /homeworks), a visible misalignment. */
    border: none;
  }
  .fc-body {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
  }
  .fc-pad-0 { padding: 0; }
  .fc-pad-6 { padding: var(--space-6); }
`;
